import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CrownIcon } from "lucide-react";
import { premiumVolumes } from "../data/landing";
import { SegmentedControl } from "./SegmentedControl";
type Mode = "sin" | "con";
const copy = {
  sin: "Sabés cocinar las recetas de los 6 tomos y los invitados quedan contentos.",
  con: "Dominás técnicas de chef profesional y coordinás menús completos de entrada, principal y postre que dejan a todos genuinamente impresionados."
};
export function PremiumUpsell() {
  const [mode, setMode] = useState<Mode>("con");
  return <section className="bg-forestDeep text-paper" data-id="element-243" data-mp="al54bec8cnfu">
      <div className="mx-auto max-w-6xl px-5 py-12 md:px-8 md:py-24" data-id="element-244" data-mp="alwqjyjxt8tg">
        <div className="max-w-2xl" data-id="element-245" data-mp="5nv556z1gxet">
          <p className="flex items-center gap-2 text-sm font-semibold text-gold" data-id="element-246" data-mp="5kh4q49xqya0">
            <CrownIcon className="h-4 w-4" aria-hidden data-id="element-247" data-mp="mpa32hwoy24" /> ¿Qué agregan los 2 tomos premium?
          </p>
          <h2 className="mt-2 font-display text-[28px] leading-tight md:mt-3 md:text-5xl" data-id="element-248" data-mp="3rujw32jioy1k">
            Para anfitrionas que quieren protagonizar cada festejo, no solo recibirlo
          </h2>
          <p className="mt-3 font-display text-lg italic leading-snug text-goldSoft md:mt-5 md:text-xl" data-id="element-249" data-mp="2qltzktfqrq9i">
            Sin los tomos premium la mesa queda rica. Con los tomos premium la mesa queda legendaria.
          </p>
        </div>
        {/* Mobile toggle */}
        <div className="mt-6 md:hidden" data-id="element-250" data-mp="34k0r7ru3ku0q">
          <SegmentedControl<Mode> label="Comparar Premium" tone="dark" value={mode} onChange={setMode} options={[{
          value: "sin",
          label: "Sin Premium"
        }, {
          value: "con",
          label: "Con Premium"
        }]} data-id="element-251" data-mp="34l25042hzum5" />
          <div className={`mt-3 rounded-2xl p-4 transition-colors duration-200 ${mode === "con" ? "bg-forest ring-1 ring-gold/50" : "bg-paper/5"}`} data-id="element-252" data-mp="2zna80vmzxib3">
            <AnimatePresence mode="wait" initial={false} data-id="element-253" data-mp="1o6aho5k7ldjp">
              <motion.p key={mode} initial={{
              opacity: 0,
              y: 4
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -4
            }} transition={{
              duration: 0.16,
              ease: [0.23, 1, 0.32, 1]
            }} className={`text-[15px] leading-relaxed ${mode === "con" ? "text-paper" : "text-paper/70"}`} data-id="element-254" data-mp="1o3o4nqeju5u3">
                {copy[mode]}
              </motion.p>
            </AnimatePresence>
          </div>
        </div>
        {/* Desktop side-by-side */}
        <div className="mt-12 hidden gap-px overflow-hidden rounded-2xl bg-paper/15 md:grid md:grid-cols-2" data-id="element-255" data-mp="332v9u66velew">
          <div className="bg-forestDeep p-8" data-id="element-256" data-mp="2y53cgwngi73b">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-paper/60" data-id="element-257" data-mp="2y5v3rva0tins">Sin Premium</h3>
            <p className="mt-3 text-lg leading-relaxed text-paper/75" data-id="element-258" data-mp="wcnfhwcfjqpr">{copy.sin}</p>
          </div>
          <div className="bg-forest p-8" data-id="element-259" data-mp="rdkld6xzn4wk">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gold" data-id="element-260" data-mp="relyri2h83hg">Con Premium</h3>
            <p className="mt-3 text-lg leading-relaxed" data-id="element-261" data-mp="yw1w1ghlopr4">{copy.con}</p>
          </div>
        </div>
        <h3 className="mt-8 text-sm font-semibold text-paper/70 md:mt-16" data-id="element-262" data-mp="13v4v8kawg1r6">Los 2 tomos premium incluyen:</h3>
        <ul className="mt-4 grid gap-5 md:mt-6 md:grid-cols-2 md:gap-10" data-id="element-263" data-mp="18o7ossfofb7d">
          {premiumVolumes.map(v => <li key={v.code} className="flex gap-4 md:gap-5" data-id="element-264" data-mp="1dl7vn5kcohzj">
              <span className="font-display text-3xl text-gold md:text-4xl" data-id="element-265" data-mp="fz0u64jcf5re">{v.code}</span>
              <div data-id="element-266" data-mp="kwsloxg2spv2">
                <h4 className="font-display text-xl leading-tight md:text-2xl" data-id="element-267" data-mp="ky3mqpi4zjih">{v.title}</h4>
                <p className="mt-1.5 text-sm leading-relaxed text-paper/70 md:mt-2 md:text-base" data-id="element-268" data-mp="pvdj6p3y0vft">{v.text}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}